const mockProducts = [
  {
    id: 1,
    type: "Футболка",
    title: "Itachi Crop",
    thumbs: [],
    price: 1000,
    sizes: ["s", "m", "l", "xl"],
    colors: ["black", "white"],
    material: "95% бавовна, 5% еластан",
    density: 230,
  },
  {
    id: 2,
    type: "Футболка",
    title: "Назва речі 2",
    thumbs: [],
    price: 1200,
    sizes: ["s", "m", "l", "xl"],
    colors: ["black", "white"],
    material: "95% бавовна, 5% еластан",
    density: 230,
  },
  {
    id: 3,
    type: "Худі",
    title: "Назва речі 3",
    thumbs: [],
    price: 1300,
    sizes: ["s", "m", "l", "xl"],
    colors: ["black", "white"],
    material: "95% бавовна, 5% еластан",
    density: 230,
  },
  {
    id: 4,
    type: "Носочки",
    title: "Назва речі 4",
    thumbs: [],
    price: 1400,
    sizes: ["s", "m", "l", "xl"],
    colors: ["black", "white"],
    material: "95% бавовна, 5% еластан",
    density: 230,
  },
];

module.exports = { mockProducts };
